import { promiseAll } from 'utils/apiHelpers'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function mrl(instance) {
	return {
		/**
		 * @param {number} farmId
		 * @param {number} varietyId
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (farmId, varietyId, pageNumber, pageSize, config = {}) => {
			const farmParm = farmId ? `farmId=${farmId}&` : ''
			const varietyParam = varietyId ? `varietyId=${varietyId}&` : ''
			const params =
				!!pageNumber && !!pageSize
					? `?${farmParm}${varietyParam}pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`mrls/index${params}`, config)
		},
		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getStatuses: (config = {}) => {
			return instance.get(`mrls/statuses`, config)
		},

		/**
		 * @param {number} farmId
		 * @param {number} varietyId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getfarmHistory: (farmId, varietyId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `&pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''

			return instance.get(
				`mrls/history?farmId=${farmId}&varietyId=${varietyId}${params}`,
				config
			)
		},
		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('mrls', body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`mrls/${id}`, config)
		},
		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		saveAll: (body, config = {}) => {
			const requests = body.map((createBody) => {
				return () => instance.post('mrls', createBody, config)
			})
			return promiseAll(requests)
		}
	}
}
